import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    ScrollView,
    TouchableOpacity
} from 'react-native';

import {
    JDText,
    JDLogin,
    JDImage,
    JDJumping,
    JDNativeSystem
} from '@jdreact/jdreact-core-lib';

import Nav from '../components/common/nav';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import OpeningHint from '../components/common/opening-hint';

import img from '../common/img';
import st from '../style/login.st';

import { get } from '../common/fetch';
import { pt, mtaPV, mta, getCookie, tip, isWeb } from '../common/utils';

class Login extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isLogin: false, // 是否登陆
            mineInfo: null,
            userPin: '' // 用户名
        };
    };

    render() {
        const { userPin, mineInfo } = this.state;

        return (
            <View style={ st.container }>
                <ScrollView
                    showsVerticalScrollIndicator={ false }
                    style={ { flex: 1 } }
                >

                    <LinearGradient
                        colors={ ['#FF4F18', '#FF2000', '#F10000'] }
                        start={ { x: 0, y: 0 } }
                        end={ { x: 0, y: 1 } }
                    >
                        <View style={ st.banner }>
                            <View style={ st.banner_top }>

                                <JDImage style={ st.avatar } source={ img.use } />

                                {!userPin && <TouchableOpacity
                                    onPress={ () => this.login() }
                                    activeOpacity={ 0.5 }
                                >
                                    <View style={ { flexDirection: 'row', marginLeft: pt(9), alignItems: 'center' } }>
                                        <JDText style={ st.banner_login }>登录/</JDText>
                                        <JDText style={ st.banner_login }>注册</JDText>
                                    </View>
                                </TouchableOpacity>}

                                {!!userPin && <JDText style={ st.username }>{userPin}</JDText>}

                            </View>

                            <View style={ st.banner_circle1 } />

                            <View style={ st.banner_circle2 } />

                            <View style={ st.banner_circle3 } />

                        </View>
                    </LinearGradient>

                    {/* <View style={ st.banner_bottom }>
                        <TouchableOpacity onPress={ () => this.toOrderList() }>
                            <View style={ st.banner_sum }>
                                <JDImage style={ st.banner_img } source={ img.movie1 } />
                                <JDText style={ st.banner_text }>电影票订单</JDText>
                            </View>
                        </TouchableOpacity>

                        <View style={ st.banner_mid } />

                        {getCookie('movie_channel') != 4 && <TouchableOpacity onPress={ () => this.toShowList() }>
                            <View style={ st.banner_sum }>
                                <JDImage style={ [st.banner_img, { height: pt(24) }] } source={ img.group2 } />
                                <JDText style={ st.banner_text }>演出票订单</JDText>
                            </View>
                        </TouchableOpacity>}
                    </View>

                    {/* 开场提示 */}
                    <OpeningHint isDialog={ false } ref={ (hint) => this._hint = hint } />

                    <View style={ st.content }>
                        {/*  电影票订票 */}
                        <TouchableOpacity style={ st.contetn_item } onPress={ () => { this.toOrderList(); } }>
                            <View style={ st.content_specia }>
                                <View style={ st.content_left }>
                                    <View style={ [st.content_left_mark_wrap, st.content_ding] }>
                                        <JDText style={ st.content_left_mark }>订</JDText>
                                    </View>
                                    <JDText style={ st.content_left_text }>电影票订单</JDText>
                                </View>

                                <View style={ st.content_right }>
                                    <JDImage style={ st.content_right_img } source={ img.o_right } />
                                </View>

                            </View>
                        </TouchableOpacity>
                        {/*  优惠券兑换 */}
                        {getCookie('movie_channel') !== 4 && <TouchableOpacity style={ st.contetn_item } onPress={ () => { this.coupon(); } }>
                            <View style={ st.content_specia }>
                                <View style={ st.content_left }>
                                    <View style={ st.content_left_mark_wrap }>
                                        <JDText style={ st.content_left_mark }>惠</JDText>
                                    </View>
                                    <JDText style={ st.content_left_text }>优惠券兑换</JDText>
                                </View>

                                <View style={ st.content_right }>
                                    <JDImage style={ st.content_right_img } source={ img.o_right } />
                                </View>

                            </View>
                        </TouchableOpacity>}

                        {/*  电影兑换券 */}
                        <TouchableOpacity style={ st.contetn_item } onPress={ () => { this.goMovieCard(); } }>
                            <View style={ st.content_specia }>
                                <View style={ st.content_left }>
                                    <View style={ [st.content_left_mark_wrap, st.content_quan] }>
                                        <JDText style={ st.content_left_mark }>兑</JDText>
                                    </View>
                                    <JDText style={ st.content_left_text }>电影兑换券</JDText>
                                </View>

                                <View style={ st.content_right }>
                                    <JDText style={ st.content_right_text }>{mineInfo && mineInfo.availableCertAmount > 0 ? mineInfo.availableCertAmount : ''}</JDText>
                                    <JDImage style={ st.content_right_img } source={ img.o_right } />
                                </View>
                            </View>
                        </TouchableOpacity>

                        {/*  京东影点卡 */}
                        <TouchableOpacity style={ st.contetn_item } onPress={ () => { this.getYindDouList(); } }>
                            <View style={ st.content_specia }>
                                <View style={ st.content_left }>
                                    <View style={ [st.content_left_mark_wrap, st.content_ying] }>
                                        <JDText style={ st.content_left_mark }>影</JDText>
                                    </View>
                                    <JDText style={ st.content_left_text }>京东影豆卡</JDText>
                                </View>

                                <View style={ st.content_right }>
                                    {/* <JDText style={ st.content_right_text }>{mineInfo && mineInfo.availableCertAmount > 0 ? mineInfo.availableCertAmount : ''}</JDText> */}
                                    <JDImage style={ st.content_right_img } source={ img.o_right } />
                                </View>
                            </View>
                        </TouchableOpacity>

                    </View>

                    <View style={ st.foot }>
                        {/*  想看的电影 */}
                        <TouchableOpacity style={ st.foot_item } onPress={ () => { this.goHistory(0); } }>
                            <View style={ st.foot_special }>
                                <JDText style={ st.foot_left }>想看的电影</JDText>

                                <View style={ st.foot_right }>
                                    <JDText style={ st.foot_right_text }>{mineInfo && mineInfo.wantMovieAmount > 0 ? mineInfo.wantMovieAmount : ''}</JDText>
                                    <JDImage style={ st.foot_right_img } source={ img.o_right } />
                                </View>
                            </View>
                        </TouchableOpacity>

                        {/*  看过的电影 */}
                        <TouchableOpacity style={ st.foot_item } onPress={ () => { this.goHistory(1); } }>
                            <View style={ st.foot_special }>
                                <JDText style={ st.foot_left }>看过的电影</JDText>

                                <View style={ st.foot_right }>
                                    <JDText style={ st.foot_right_text }>{mineInfo && mineInfo.seenMovieAmount > 0 ? mineInfo.seenMovieAmount : ''}</JDText>
                                    <JDImage style={ st.foot_right_img } source={ img.o_right } />
                                </View>
                            </View>
                        </TouchableOpacity>

                        {/*  去过的影院 */}
                        <TouchableOpacity style={ st.foot_item } onPress={ () => { this.goHistory(2); } }>
                            <View style={ st.foot_special }>
                                <JDText style={ st.foot_left }>去过的影院</JDText>

                                <View style={ st.foot_right }>
                                    <JDText style={ st.foot_right_text }>{mineInfo && mineInfo.goneCinemaAmount > 0 ? mineInfo.goneCinemaAmount : ''}</JDText>
                                    <JDImage style={ st.foot_right_img } source={ img.o_right } />
                                </View>
                            </View>
                        </TouchableOpacity>
                    </View>

                    <View style={ st.feedback }>
	                    <TouchableOpacity style={ st.foot_item } onPress={ () => { this.refundChangeSignature(); } }>
		                    <View style={ st.foot_special }>
			                    <JDText style={ st.foot_left }>退改签协议</JDText>
			                    
			                    <View style={ st.foot_right }>
				                    <JDText style={ st.feedback_txt }></JDText>
				                    <JDImage style={ st.foot_right_img } source={ img.o_right } />
			                    </View>
		                    </View>
	                    </TouchableOpacity>
                        {
                            !isWeb && (
                                <TouchableOpacity style={ st.foot_item } onPress={ () => { this.goFeedgack(); } }>
                                    <View style={ st.foot_special }>
                                        <JDText style={ st.foot_left }>意见反馈</JDText>

                                        <View style={ st.foot_right }>
                                            <JDText style={ st.feedback_txt }>吐槽产品获得好礼哦 </JDText>
                                            <JDImage style={ st.foot_right_img } source={ img.o_right } />
                                        </View>
                                    </View>
                                </TouchableOpacity>
                            )
                        }

                        <TouchableOpacity style={ st.foot_item } onPress={ () => { this.goHelp(); } }>
                            <View style={ st.foot_special }>
                                <JDText style={ st.foot_left }>帮助中心</JDText>

                                <View style={ st.foot_right }>
                                    <JDText style={ st.feedback_txt }>购票、退票、开票须知 </JDText>
                                    <JDImage style={ st.foot_right_img } source={ img.o_right } />
                                </View>
                            </View>
                        </TouchableOpacity>
                    </View>

                </ScrollView>

                {/* 底部导航栏 */}
                <Nav />

                <View style={ {
                    height: JDNativeSystem.iphoneXMarginBottom,
                    backgroundColor: '#fff',
                    width: '100%'
                } } />

            </View>
        );
    }

    componentDidFocus() {
        mtaPV('My');

        // 开场提示
        this._hint.hintStorage();

        this.props.dispatch({
            type: 'change_label',
            label: 3
        });

        // 金融渠道的展示
        if (+getCookie('movie_channel') === 4) {
            this.props.dispatch({
                type: 'change_label',
                label: 1
            });
        }

        JDLogin.isLogin().then(() => {
            this.setState({
                isLogin: true
            });

            this.getInfo();
        }).catch(() => { });
    }

    getInfo() {
        get('showingMineHomeInfo', {}).then(res => {
            this.setState({
                mineInfo: res.data,
                userPin: res.data.userPin
            });
        });
    }

    login(fnName, page) {
        const { mineInfo } = this.state;

        if (!fnName) {
            mta('MyLogin', 'My');
        }

        JDLogin.doLogin().then(() => {
            // 开场提示
            this._hint.hintStorage();

            if (mineInfo == null) {
                this.getInfo();
            }

            this.setState({
                isLogin: true
            }, () => {
                fnName && this[fnName](page);
            });
        }, () => {
            JDLogin.doLogin().then(() => {
                this.setState({
                    isLogin: true
                });
            });
        });
    }
	
	
	// 退改签协议
	refundChangeSignature() {
		this.context.router.toRefundChange({ from: 2 });
	}

    // 意见反馈
    goFeedgack() {
        mta('MyFeed', 'My');

        const url = 'openApp.jdMobile://virtual?params={"category":"jump","sourceValue":"sourceValue_test","sourceType":"sourceType_test","des":"feedback","from":"dianyingpiao"}';

        JDJumping.jumpToOpenapp(url).catch(err => tip(err));
    }

    // 帮助中心
    goHelp() {
        const url = 'https://pro.m.jd.com/mall/active/47iENGjHENPgBsYh2rCEKPbHL7nf/index.html';

        JDJumping.jumpToWeb(url).catch(err => tip(err));
    }

    // 电影票订单跳转函数
    toOrderList() {
        mta('MyMovieOrd', 'My');
        if (this.state.isLogin) {
            this.context.router.toOrderList();
        } else {
            this.login('toOrderList');
        }
    }

    // 演出票订单跳转函数
    toShowList() {
        mta('MyPerformanceOrd', 'My');
        if (this.state.isLogin) {
            const url = 'https://m-piao.jd.com/myOrders';

            JDJumping.jumpToWeb(url).catch(err => tip(err));
        } else {
            this.login('toShowList');
        }
    }

    // 优惠券兑换跳转函数
    coupon() {
        mta('MyCouponExchan', 'My');
        if (this.state.isLogin) {
            const url = 'https://quan.jd.com/m/exchange_coupon.action';

            JDJumping.jumpToWeb(url).catch(err => tip(err));
        } else {
            this.login('coupon');
        }
    }

    // 已领券跳转函数
    didcoupon() {
        // mta('MyTicketExchan', 'My');
        if (this.state.isLogin) {
            const url = 'https://quan.jd.com/m/exchange_coupon.action';

            JDJumping.jumpToWeb(url).catch(err => tip(err));
        } else {
            this.login('didcoupon');
        }
    }

    //  电影卡列表
    goMovieCard() {
        mta('MyTicketExchan', 'My');

        if (this.state.isLogin) {
            this.context.router.toMovieCardList({ from: 2 });
        } else {
            this.login('goMovieCard');
        }
    }

    // 影点卡列表
    getYindDouList = () => {
        if (this.state.isLogin) {
            this.context.router.toYingdouList();
        } else {
            this.login('getYindDouList');
        }
    }

    // PLUS大地会员卡跳转函数
    plus() {
        if (this.state.isLogin) {
            const url = 'https://quan.jd.com/m/exchange_coupon.action';

            JDJumping.jumpToWeb(url).catch(err => tip(err));
        } else {
            this.login('plus');
        }
    }

    // 想看的电影跳转函数
    /**
 *  @param {Number} type 0想看 1看过 2去过
 */
    goHistory(page) {
        const type = ['MyMovieWant', 'MyMovieSaw', 'MyCinemaBeen'];

        mta(type[page], 'My');

        if (this.state.isLogin) {
            this.context.router.toHistory({ page });
        } else {
            this.login('goHistory', page);
        }
    }
}

Login.contextTypes = { router: PropTypes.object };

const select = () => {
    return {
    };
};

export default connect(select, null, null, { withRef: true })(Login);
